import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import { createComponent } from '../../services/components';
import { derivePropsFromObject, getItemKey } from '../../services/props';
export function componentIterator(_ref) {
  var iterator = _ref.iterator,
    component = _ref.component,
    _ref$propMap = _ref.propMap,
    propMap = _ref$propMap === void 0 ? [] : _ref$propMap,
    _ref$itemKey = _ref.itemKey,
    itemKey = _ref$itemKey === void 0 ? '' : _ref$itemKey,
    iteratorObject = _ref[0];
  var finalIterator = iterator;
  if (_isFunction(iterator)) {
    finalIterator = iterator(iteratorObject);
  }
  if (_isEmpty(finalIterator)) {
    return null;
  }
  return finalIterator.map(function (item) {
    var props = _objectSpread(_objectSpread({}, derivePropsFromObject(item, propMap, finalIterator)), {}, {
      key: getItemKey(item, itemKey)
    });
    return createComponent(component, props);
  });
}